<template>
    <div>
        <div class="host-item" v-bind:style="{'backgroundColor': host.host_color}">
          <div class="top-bar">
            <host-info :host="host" :host-index="hostIndex" :aria-expanded="showPrinters ? 'true' : 'false'"
                       :aria-controls="collapseId" @toggle="showPrinters = !showPrinters"></host-info>
            <host-actions :host="host" :host-index="hostIndex" :printers="printers"></host-actions>
          </div>

            <b-collapse :id="collapseId" class="table table--files table--jobs only-printers" v-model="showPrinters">
                <printers-list :printers="printers" grouped></printers-list>
            </b-collapse>
        </div>
    </div>
</template>

<script>

    import HostInfo from './host/HostInfo';
    import HostActions from './host/HostActions';
    import PrintersList from './PrintersList';

    export default {
        name: 'host-item',
        props: ['host', 'hostIndex'],
        components: {
            HostInfo,
            HostActions,
            PrintersList
        },
        data() {
            return {
                showPrinters: true
            }
        },
        computed: {
            collapseId() {
                return 'host-collapse-' + this.host.host_id
            },
            printers() {
                return this.$store.getters.getActivePrintersByHost(this.host.host_id);
            }
        }

    }
</script>


<style lang="scss">
  @import "../../scss/theme";


    .host-item {
      background-color: $c-primary;
      border-radius: $s-border-radius;
      cursor: pointer;
      margin: 20px -12px 0px;
      padding: 12px 18px;
      display: block;

      .files-page__projects-tab .collapse {
        margin-bottom: 0;
      }

        .only-printers {
            margin: 12px 0 0;
            .printers-table__item {
                margin-bottom: 16px;
                &__queue {
                    margin-top: -16px;
                    &.collapsed * {
                        color: white;
                    }
                }
            }
        }
    }
</style>